  <template>
    <section class="about-section">
      <h2>Über uns</h2>
      <div class="about-text">
        <p>
          <strong>Authentische Sichuan-Kulinarik, meisterhaft zelebriert</strong>
        </p>
         <p>
           „Rong Cheng Ji Yi“ versteht sich als authentisches Refugium der Sichuan-Kochkunst. Wir huldigen den traditionellen Zubereitungsarten und verwenden ausschließlich erlesene, regionale Zutaten aus Sichuan, um den unverfälschten Geschmack Chengdus zu rekreieren. Unser Küchenteam, bestehend aus versierten Koryphäen der Sichuan-Küche, hat die Quintessenz dieser Kochtradition – „ein Gericht, ein Charakter; hundert Gerichte, hundert Geschmacksnuancen“ – verinnerlicht. Virtuos beherrschen sie das Spiel mit den vielschichtigen Aromen von „Ma“ (prickelnder Schärfe), „La“ (feuriger Schärfe), „Xian“ (umami-reicher Frische) und „Xiang“ (intensivem Duft), um die Farbe, das Aroma, den Geschmack, die Textur und die Präsentation der Sichuan-Gerichte in vollendeter Harmonie zu vereinen.
        </p>
  
        <!-- Hier können weitere Absätze mit zusätzlichen Informationen folgen -->
        <!-- <p>
          <strong>Klassiker der Sichuan-Küche</strong>
          
        </p> -->
        <h2>Klassiker der Sichuan-Küche</h2>
      </div>
      <div class="image-gallery">
      <img src="../assets/beef.png" alt="Gericht 1" class="gallery-image">
      <img src="../assets/fish.png" alt="Gericht 2" class="gallery-image">
      <img src="../assets/doufu.png" alt="Gericht 3" class="gallery-image">
      <img src="../assets/yuxiangrousi.png" alt="Gericht 4" class="gallery-image">
      <img src="../assets/gongbaojiding.png" alt="Gericht 5" class="gallery-image">
      <img src="../assets/ganguogeichang.png" alt="Gericht 6" class="gallery-image">
    </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'AboutSection',
  };
  </script>
  
  <!-- <style scoped>
  .about-section {
    padding: 2rem 1rem;
    max-width: 800px; /* 最大宽度限制 */
    margin: 0 auto; /* 水平居中 */
    line-height: 1.6; /* 调整行高 */
    color: #333;
  }
  
  .about-section h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #333; /* Consistent color with the rest of the text */
  }
  
  .about-text p {
      margin-bottom: 1rem; /* Spacing between paragraphs */
  }
  
  .about-text strong {
    /*  Optional: Style for the headings, if you want them different  */
  }
  .image-gallery {
  display: grid;             /* 使用 Grid 布局 */
  grid-template-columns: repeat(3, 1fr); /* 三列，每列宽度相等 */
  grid-gap: 1rem;            /* 图片之间的间距 */
  margin-top: 2rem;          /* 图片区域与上方文字的间距 */
}

.gallery-image {
  width: 100%;              /* 图片宽度填满格子 */
  height: auto;             /* 图片高度自动调整 */
  display: block;            /* 消除图片底部间隙 */
  aspect-ratio: 1 / 1; /* 保持 1:1 的宽高比 (正方形) */
  object-fit: cover;  /*  重要：保持宽高比并裁剪以适应 */
  border-radius: 8px;       /* 可选：添加圆角 */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  可选：添加阴影 */
}
  
  
  /*移动端*/
  @media (max-width: 768px) {
    .about-section {
      padding: 1rem 0.5rem;
    }
    .about-section h2 {
      font-size: 1.5rem;
    }
    .image-gallery {
    grid-template-columns: repeat(2, 1fr); /* 移动端改为两列 */
    grid-gap: 0.5rem; /* 移动端减小间距 */
  }
  }
  </style> -->
  <style scoped>
.about-section {
  position: relative; /* 重要：设置为相对定位 */
  padding: 2rem 1rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  color: #333;
  z-index: 0; /* 确保内容在背景之上 */
}

/* 伪元素用于创建背景图片 */
.about-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/rc_logo1.png'); /* 替换为你的背景图片路径 */
  background-size: cover; /* 或者 contain, 根据你的需求 */
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.2; /* 设置透明度 */
  z-index: -1; /* 将背景图片置于内容之后 */
}


.about-section h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #333;
}

.about-text p {
  margin-bottom: 1rem;
}

.about-text strong {
  /* Optional: Style for the headings */
}

.image-gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
  margin-top: 2rem;
}

.gallery-image {
  width: 100%;
  height: auto;
  display: block;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 8px;
}

/* 移动端 */
@media (max-width: 768px) {
  .about-section {
    padding: 1rem 0.5rem;
  }
  .about-section h2 {
    font-size: 1.5rem;
  }
  .image-gallery {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0.5rem;
  }

    /* 可选: 如果在移动端需要不同的背景透明度 */
  /* .about-section::before {
    opacity: 0.3;
  } */
}
</style>